import React from "react";
import { CalendarDays, MapPin, Users, FileText } from "lucide-react";

const BestPapers25 = () => {
  /* -------------------- DATA -------------------- */

const papers = [
  {
    id: 274,
    title:
      "A Blockchain-based Framework for Voting System on Ethereum Blockchain",
    authors:
      "Anshika Jain, Yash Chawla, Sukrit Kaur Oberoi, Sejal Joshi, Vipin Deval, Bharti Chugh",
  },
  {
    id: 328,
    title:
      "A Framework for Text Sentiment Analysis of Social Media Tweets Using Large Language Models",
    authors:
      "Rajesh Sura, Kapil Kumar Goyal, Surendra Narang, Gopikrishna Maddali",
  },
  {
    id: 387,
    title:
      "Early Lung Cancer Detection Using LungNetCIRv2: Advanced Hybrid Framework Combining CNN and InceptionResNetV2",
    authors:
      "R.G. Suresh Kumar, A. Swathi Arumugam, Udhaya Shree, T. Rajan Babu, D. Suganya",
  },
  {
    id: 552,
    title:
      "A Comprehensive Review of Bio-Inspired and Artificial Intelligence Algorithms Applied in Healthcare",
    authors: "Abirami T, W. Rose Varuna",
  },
  {
    id: 561,
    title: "Truth Entangled: Contrastive Method for Hybrid Text Detection",
    authors:
      "Shraddha Vaidya, Jatinderkumar R. Saini, Sujata Katkade",
  },
  {
    id: 562,
    title:
      "HalluCon: Detecting Hallucinations in Question-Answer Systems using Contrastive Learning",
    authors:
      "Shraddha Vaidya, Jatinderkumar R. Saini, Rutuja Rathod, Poonam Surve",
  },
  {
    id: 567,
    title: "Breast Cancer Detection Using Deep Learning",
    authors:
      "Remya R, Reji R, Divya Saleela, Reshma Lucos, Chinchu M S, Vimal, Sarath Gopal, Riyas A, Akhil Mathew Philip",
  },
  {
    id: 598,
    title:
      "A Novel Approach to Mitigate Information Spread on Social Networks",
    authors:
      "Kendre Priyanka Kashinath, Jayashri D. Palkar, Anusha Omkar Vaidya, Chetana Hasmukh Jain, Snehal Shinde, Yogesh Mali, Vishal Borate",
  },
  {
    id: 669,
    title:
      "Bridging Natural Language and Autonomous Action: LLM-Driven AI Agents for Human-Machine Collaboration",
    authors:
      "Fahmida Binte Khair, Farhana Karim, Mukther Uddin, Abdullah Al Zaiem, Sraboni Clara Mohonta, Mohammad Somon Sikder, Khadeza Yesmin Lucky",
  },
  {
    id: 670,
    title:
      "Adaptive Multi-Modal AI Agents: Leveraging Large Language Models for Dynamic Real-World Environments",
    authors:
      "Md Ekrim Hossin, Md Imtiaz Faruk, Md Talha Bin Ansar, Udoy Sankar Saha, Syed Mohammed Muhive Uddin, Monjira Bashir, Mohammad Somon Sikder",
  },
  {
    id: 720,
    title:
      "AI-Powered Intrusion Detection System for Securing IoT Smart Home Environments",
    authors: "Hamza Afzal, Malik Huzaifa",
  },
  {
    id: 721,
    title:
      "Optimizing Ensemble Models with Cognitive Computing: A Dual-Level Pruning Approach for Enhanced Decision-Making",
    authors:
      "Anjaneyulu Kunchala, Sudhir Kumar Tiwari, Abhishek Raj Permani, Duraibabu Lakshmipathy, Priyanka Sharma, Stuti Shandilya, Nidhi Agarwal",
  },
  {
    id: 733,
    title:
      "Interactive Memory Management: The Model Context Protocol (MCP) as an Orchestration Layer for LLM Agents",
    authors: "Chandra Sekhar Kubam",
  },
  {
    id: 736,
    title:
      "Scalable Architectures for LLM-Based AI Agents in Distributed and Collaborative Ecosystems",
    authors:
      "Gayatri Tavva, Ankush Jitendrakumar Tyagi, Viharika Bhimanapati",
  },
  {
    id: 738,
    title:
      "Achieving Atomic Context Consistency in Large-Scale Multi-Agent Systems via Decentralized Trust-Weighted Consensus",
    authors: "Anam Haider Khan, Mohan Kumar Meesala",
  },
];

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-5xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800">
            Best Papers - ICCRDA 2025
          </h1>
          
          <hr className="mt-4 mx-auto w-48 border-2 border-indigo-600" />
        </div>

        {/* Papers Table */}
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 mb-10">
          <div className="overflow-x-auto">
            <table className="min-w-full border text-sm">
              <thead className="bg-slate-100">
                <tr>
                  <th className="border px-4 py-2">Paper ID</th>
                  <th className="border px-4 py-2">Paper Title</th>
                  <th className="border px-4 py-2">Author(s)</th>
                </tr>
              </thead>
              <tbody>
                {papers.map((p) => (
                  <tr key={p.id} className="hover:bg-slate-50">
                    <td className="border px-4 py-2 font-medium">{p.id}</td>
                    <td className="border px-4 py-2">{p.title}</td>
                    <td className="border px-4 py-2">{p.authors}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default BestPapers25;
